module.exports = __webpack_public_path__ + "img/advisor-img2.8851c59c.jpg";